// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ImagensServicos_DeletarFotoAjaxInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/imagens_servicos/deletar_foto_ajax/{imagem_id}
 *
 * Deletes a service photo. No body required — imagem_id is a URL path parameter.
 */
import { registerContract } from './validate'

export interface ImagensServicos_DeletarFotoAjaxInput {}

registerContract('ImagensServicos_DeletarFotoAjaxInput', {})
